/** @format */

import {SensorGroupColorType} from 'types';

import {ChartIds} from '../../models/chartIds';

const getSensorGroupByChartId = (chartId: ChartIds): SensorGroupColorType => {
  switch (chartId) {
    case 'sensorRed':
      return 'RED';
    case 'sensorYellow':
      return 'YELLOW';
    case 'sensorGray':
      return 'GRAY';
    default:
      throw new Error('Группа сенсора не найдена');
  }
};

export {getSensorGroupByChartId};
